import React from 'react';
import { View } from 'react-native';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import RadioButton from 'design-system/RadioButton';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import RowAccount from 'features/accounts/components/RowAccount';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { isDesktopOrWeb } from '../../../../constants';
const KeyboardAccountsRow = ({ item, onPress, type, isSelected, isBeforeSectionHeader }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<TouchableHighlight onCard hoverOnLight onPress={onPress} activeOpacity={1} underlayColor={colors.background.underlay} style={!!isBeforeSectionHeader && styles.beforeSectionHeader}>
      <View style={styles.container}>
        <RadioButton isChecked={isSelected} type={type}/>
        <Spacer w={16}/>
        <View style={styles.flex} pointerEvents="none">
          <RowAccount data={item} style={styles.row} onPress={onPress} onCard={isDesktopOrWeb}/>
        </View>
      </View>
    </TouchableHighlight>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    row: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    beforeSectionHeader: {
        marginBottom: rem(4),
    },
}));
export default KeyboardAccountsRow;
